import { EuiLoadingSpinner, EuiText, EuiButtonIcon, EuiIcon, EuiBasicTable } from "@elastic/eui"
import { useEffect, useState } from "react";
import { formatDateTime } from "../../../../../../shared/utils/fecha";

export const DetalleContent = (props:any) =>{

    const {item, onDetalleFilter, onInvalidar, todosValidados, onValidarCG, usrCG, usrDN, validaFinal, tipoContenido, padreValidado} = props;

    const [detalle, setDetalle] = useState<any>(undefined)

    const getData = async() =>{
        await onDetalleFilter && onDetalleFilter(item).then((value:any) => {setDetalle(value)})
    }

    // const getColorText = (estado:number) =>{
    //     switch (estado) {
    //         case 0: return 'secondary';
    //         case 1: return 'danger';
    //         case 2: return 'warning';
    //         default: return 'default';
    //     }
    // }

    // const getColorMarket = (estado:number) =>{
    //     switch (estado) {
    //         case 0: return '';
    //         case 1: return 'error-state';
    //         case 2: return 'warning-state';
    //         default: return '';
    //     }
    // }
    
    const tWidht = '100px';

    const columns = [
        {
          width: '70px',
          field: 'idCentro',
          name: 'IdCentro',
          sortable: true,
          render: (centroId: any) => centroId!==null ? centroId : '',
        },
        {
          field: 'descripcion',
          name: 'Nombre',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          // field: 'subido',
          name: 'Subido',
          // sortable: true,
          width: tWidht,
          render: (item: any) => {
            const type = (item.subido ? (item.soloCentro ? 'checkInCircleFilled' : 'check') : 'cross');
            const color = (item.subido ? 'success' : 'danger');
            return <EuiIcon type={type} color={color} title={item.soloCentro ? 'Solo Area' : ''} />; 
          },
        },
        {
          name: 'Validado',
          width: tWidht,
          render: (item:any) => {
            console.log('validado render', item);
            if(item.subido && !item.validado && (usrCG || usrDN)){
              return <EuiButtonIcon
                        display='base'
                        onClick={() => onValidarCG(item.idCentro, false)}
                        iconType={'check'}
                      />
            }else{
              const type = (item.validado ? 'check' : 'cross');
              const color = (item.validado ? 'success' : 'danger');
              return <EuiIcon type={type} color={color} />;
            }
          },
        },
        {
          field: 'usuario',
          name: 'Usuario',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          field: 'fecha',
          name: 'Fecha',
          sortable: true,
          render: (fecha: any) => {
            let vFecha = '';
            if(fecha != null && fecha != undefined) vFecha = formatDateTime(fecha);
            return vFecha;
          },
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        
        {
          name: 'Validado CG',
          width: tWidht,
          render: (item:any) => {
            if( usrCG && item.validado && !item.validadoCG && (!todosValidados || (!validaFinal && usrCG))){
              return <EuiButtonIcon
                        display='base'
                        onClick={() => onValidarCG(item.idCentro, true)}
                        iconType={'check'}
                      />
            }else{
              const type = (item.validadoCG ? 'check' : 'cross');
              const color = (item.validadoCG ? 'success' : 'danger');
              return <EuiIcon type={type} color={color} />;
            }
          },
        },
        {
          field: 'usuarioCG',
          name: 'Usuario',
          sortable: true,
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          field: 'fechaCG',
          name: 'Fecha',
          sortable: true,
          render: (fecha: any) => {
            let vFecha = '';
            if(fecha != null && fecha != undefined) vFecha = formatDateTime(fecha);
            return vFecha;
          },
          truncateText: false,
          enlarge: true,
          width: '100%',
        },
        {
          width: '70px',
          name: 'Invalidar',
          render: (item:any) => (item.validado && (!todosValidados || (!validaFinal && usrCG)) && !padreValidado && (usrCG || !item.validadoCG)) ? (
            <EuiButtonIcon
              display='base'
              onClick={() => onInvalidar(item.idCentro, false)}
              iconType={'cross'}
            />
          ) : null,
        },
      ];

    const getClassRow = (subido:boolean, validado: boolean) =>{
    if( subido && validado){
        return 'rowSuccess';
    }else if(validado && !subido){
      return 'rowWarning2';
    }else if (subido){
        return 'rowWarning';
    }else{
        return 'rowError';
    }
    }
    
    const getRowProps = (item:any) => {
    const { idCentro, subido, validado } = item;
    return {
        'data-test-subj': `row-${idCentro}`,
        className: getClassRow(subido, validado),
    };
    };

    const getDetalles = ()=>{
        // return detalle.map((d:any,i:number)=>{
        //     return (<>
        //     <li className={`market ${getColorMarket(d.idTipoError)}`}><EuiText key={d.idImportacion} size={'s'} color={getColorText(d.idTipoError)}>{d.descripcion}</EuiText></li>
        //     {detalle[i+1] && <hr className={`hr ${getColorMarket(d.idTipoError)}`}/>}
        //    </>) 
        // })
        
        return(
            <EuiBasicTable
                id='tabla-log-importaciones-detalle'
                items={detalle}
                itemId="idCentro"
                columns={columns}
                rowProps={getRowProps}
                // onChange={onTableChange}
                // sorting={sorting}
                // responsive={true}
                // itemIdToExpandedRowMap={itemIdToExpandedRowMap}
                isExpandable={false}
                // isSelectable
                noItemsMessage
                className='tablaAjustar'
            />
        )
    }

    useEffect(()=> {
       getData();
    },[])

    console.log('usr CG getDetalles', usrCG)
    return detalle ? <ul className='lista-detalle-log'>{getDetalles()}</ul> :  <EuiLoadingSpinner size="m" />
}